/**
 * Le picto d'une entité (projet, espace wiki) est le NOM d'une icône Lucide —
 * celui que pose la bibliothèque d'icônes (`IconLibrary`), et que rend
 * `<Picto>` / l'élément reactive-json `PictoIcon`.
 *
 * Helpers dans un module `.js` dédié : un export non-composant depuis un
 * fichier `.jsx` casse le Fast Refresh (react-refresh/only-export-components).
 */

/** Icône rendue quand aucun picto n'est posé. */
export const DEFAULT_PICTO = 'Folder'

/** Un nom Lucide est un identifiant PascalCase ASCII ; un emoji n'en est jamais un. */
export const isPictoName = (value) => typeof value === 'string' && /^[A-Z][A-Za-z0-9]*$/.test(value)
